import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { BlockPosValidationSchema } from "../pages/Show/schemas/blockPos.schema"

interface UseBlockPosModalProps {
  id?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useBlockPos = ({ id, onSuccess, onError }: UseBlockPosModalProps) => {
  const privateAxios = usePrivateAxios()
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['blockPos', id],
    mutationFn: async (data: BlockPosValidationSchema) => {
    await privateAxios.put(`/pos/machines/${id}/block`, {
        pos: {
          block_reason: data.description,
        }
      })
    },
    onSuccess: () => {
      if (id) {
        queryClient.invalidateQueries({queryKey: ["posMachineById", id]});
      }
      onSuccess?.();
    },
    onError,
  })
}